//
// This filter lets you use a filter to display keyboard shortcuts:
//
//  {{ '[Meta]S' | keyboardShortcut }} ==> ⌘S
//  {{ '[Shift][Meta]R' | keyboardShortcut }} ==> ⇧⌘R
//
export default function(value) {
  const isMac = !!navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i);
  const altKey = isMac ? '⌥' : 'ALT+';
  const metaKey = isMac ? '⌘' : 'CTRL+';
  const ctrlKey = isMac ? '⌃' : 'CTRL+';
  const shiftKey = isMac ? '⇧' : 'SHIFT+';
  return value
    .replace('[Ctrl]', ctrlKey)
    .replace('[Meta]', metaKey)
    .replace('[Shift]', shiftKey)
    .replace('[Alt]', altKey);
}
